import { render } from "./ProfileDropDown.vue?vue&type=template&id=65d0720c"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"

import "./ProfileDropDown.vue?vue&type=style&index=0&id=65d0720c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__